export default __webpack_public_path__ + "static/media/content.27ee72bb.svg";